<template>
<v-text-field  :value="value" :id="id" v-model="displayValue"    :label="etiket" :name="name"  >
</v-text-field>
</template>

<script>
export default {
  name: 'duzyazi',
  data () {
    return {
      isInputActive: false,
    }
  },
  props: ['value',  'name', 'id','etiket'],
  computed: {
    displayValue: {
      get: function () {

          return this.value

      },
       set: function (newValue) {
            this.$emit('input', newValue )
        },
    }
  }
}
</script>

<style scoped>
</style>

